import * as React from 'react';
import ServiceWithSegments from '../../../../ServiceWithSegments/ServiceWithSegments';
var ModalHeader = function (props) {
    var renderScheduleTypeSelector = props.renderScheduleTypeSelector, onSegmentChange = props.onSegmentChange, segments = props.segments;
    return (React.createElement(ServiceWithSegments, { onSegmentChange: onSegmentChange, sticky: true, title: null, segments: segments, onMobileBack: function () { return null; }, onMobileProceed: function () { return null; }, renderRightBlock: renderScheduleTypeSelector }, props.children));
};
export default ModalHeader;
